import { render, staticRenderFns } from "./CompetitionShop.vue?vue&type=template&id=e342692e&scoped=true&"
import script from "./CompetitionShop.vue?vue&type=script&lang=js&"
export * from "./CompetitionShop.vue?vue&type=script&lang=js&"
import style0 from "./CompetitionShop.vue?vue&type=style&index=0&id=e342692e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e342692e",
  null
  
)

export default component.exports